module.exports = __webpack_public_path__ + "img/placeholder_2_16to9.5970a62e.svg";